<template>
  <div class="tab-container">
    <div class="tab" v-for="(tab, index) in tabs" :key="index" :class="{ active: value === index }" @click="onTabKeyChange(index)">{{ tab }}</div>
  </div>
</template>

<script>
// tab切换
export default {
  props: {
    tabs: Array,
    value: Number
  },
  methods: {
    onTabKeyChange(key) {
      this.$emit('input', key)
    }
  }
}
</script>


<style lang="less" scoped>
.tab-container {
  width: 100%;
  display: flex;
  padding: 0 16px;
  align-items: center;
  background: white;

  .tab {
    padding: 12px 16px;
    position: relative;
    margin-right: 30px;
    cursor: pointer;

    &.active {
      &::after {
        animation: showFromMid 0.2s;
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 2px;
        background: #0088ff;
      }
    }
  }
}

@keyframes showFromMid {
  from {
    left: 50%;
    right: 50%;
  }

  to {
    left: 0;
    right: 0;
  }
}

@keyframes showFromLeft {
  from {
    left: 0;
    right: 100%;
  }

  to {
    left: 0;
    right: 0;
  }
}
</style>